var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { memo, useEffect } from 'react';
import { blocksActions } from '../';
import { useFirebase } from '@web/firebase';
export var FBConnector = memo(function (_a) {
    var dispatch = _a.dispatch;
    var instance = useFirebase().instance;
    useEffect(function () {
        if (instance) {
            var formatFirestoreDocumentAsPageData_1 = function (snapshot) {
                return Object.assign.apply(Object, __spreadArray([{}], snapshot.docs.map(function (doc) {
                    var _a;
                    return (_a = {}, _a[doc.id] = __assign({}, doc.data()), _a);
                })));
            };
            var unsubscribe_1 = instance.blocks
                .where('deleted', '==', false)
                .orderBy('_title')
                .onSnapshot(function (querySnapshot) {
                console.log("%c FETCH BLOCKS ", 'background: black; color: white;');
                var list = formatFirestoreDocumentAsPageData_1(querySnapshot);
                dispatch({ type: blocksActions.SUCCESS, list: list });
            });
            return function () { return unsubscribe_1(); };
        }
    }, [instance]);
    return (React.createElement(React.Fragment, null));
});
